<template>
  <div id="app">
    <!-- Loading overlay -->
    <div v-if="loading" class="loading-overlay">
      <div class="loader"></div>
    </div>

    <!-- App notification component -->
    <app-notification />

    <!-- Main content -->
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AppNotification from '@/components/AppNotification.vue'

export default {
  name: 'AppRoot',
  components: {
    AppNotification
  },
  computed: {
    ...mapState({
      loading: state => state.notifications.loading
    })
  },
  async created() {
    // Initialize auth state on app startup
    try {
      await this.$store.dispatch('auth/initAuth')
    } catch (error) {
      console.log('Auth initialization completed (may not be logged in)')
    }
  }
}
</script>

<style>
/* Global Styles */
.subheading {
  margin-top: 0.5rem !important;
}
</style>
